// ACTIONS
export const FETCH_CAMPAIGN_FILE_NAMES = 'FETCH_CAMPAIGN_FILE_NAMES';
export const FETCH_CAMPAIGN_FILE = 'FETCH_CAMPAIGN_FILE';
export const DELETE_CAMPAIGN_FILE = 'DELETE_CAMPAIGN_FILE';
